import { useState } from 'react';

import { LogOutIcon } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { FieldsetCard } from '@/components/atoms/FieldsetCard/FieldsetCard';
import { SectionLayout } from '@/components/atoms/SectionLayout/SectionLayout';
import { MODAL_DELETE } from '@/components/organisms/Modals/ModalConductor';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { useAccount } from '@/hooks/useAccount';
import { pushModal } from '@/redux/modals/actions';

const AccountLeave = () => {
  const { t } = useTranslation();
  const { account, leaveAccount, leaveStatus } = useAccount();
  const dispatch = useDispatch();
  const [confirmed, setConfirmed] = useState(false);

  const handleLeaveClick = () => {
    const leaveProps = {
      subtitle: <Trans i18nKey="accounts.leave_subtitle" values={[account?.name]} />,
      title: t('accounts.leave'),
      primaryButtonText: t('accounts.leave'),
      forceEnablePrimaryButton: true,
      onDelete: () => {
        leaveAccount(null);
      },
    };
    dispatch(pushModal(MODAL_DELETE, leaveProps));
  };

  return (
    <SectionLayout title={t('accounts.leave')}>
      <FieldsetCard>
        <Label className="flex cursor-pointer items-start gap-3">
          <Checkbox
            className="mt-0.5"
            checked={confirmed}
            onCheckedChange={(checked) => setConfirmed(checked === true)}
          />
          <span>
            <span className="block text-sm leading-5 font-medium text-foreground">
              {t('accounts.leave_confirm')}
            </span>
            <span className="block text-sm leading-5 text-muted-foreground">
              {t('accounts.leave_description')}
            </span>
          </span>
        </Label>
      </FieldsetCard>
      <div>
        <Button
          variant="destructive-ghost"
          disabled={!confirmed}
          isLoading={leaveStatus === 'pending'}
          onClick={handleLeaveClick}
        >
          <LogOutIcon size={16} />
          {t('accounts.leave')}
        </Button>
      </div>
    </SectionLayout>
  );
};

export default AccountLeave;
